import { render, staticRenderFns } from "./LeaseBlockedPlaceholder.vue?vue&type=template&id=24ff4880&scoped=true"
import script from "./LeaseBlockedPlaceholder.vue?vue&type=script&lang=js"
export * from "./LeaseBlockedPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LeaseBlockedPlaceholder.vue?vue&type=style&index=0&id=24ff4880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff4880",
  null
  
)

export default component.exports